import { getAcademyAssistantContext } from '../stores/academyAssistantContextStore';
import { buildTurnMetadata } from './buildTurnMetadata';

/**
 * Send a message with the current video context as `turnMetadata`. When empty,
 * OMIT the option entirely (`sendMessage(text)`) so un-migrated consumers
 * behave exactly as before.
 */
export const sendMessageWithContext = (manager, text) => {
  const turnMetadata = buildTurnMetadata(getAcademyAssistantContext());
  return Object.keys(turnMetadata).length > 0 ? manager.sendMessage(text, {
    turnMetadata
  }) : manager.sendMessage(text);
};